import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {AbstractVisbosComponent} from "../../abstract-visbos.component";
import {SessionActions} from "../../../../../shared/actions/session.actions";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../../../crm/user/user.service";
import {Router} from "@angular/router";
import {MessageType} from "../../../../../shared/redux-store/session/session.types";

@Component({
  selector: 'vb-password-reset-link',
  templateUrl: './password-reset-link.component.html',
  styleUrls: ['./password-reset-link.component.css']
})
export class PasswordResetLinkComponent extends AbstractVisbosComponent implements OnInit {

  form: FormGroup;

  constructor(sessionActions: SessionActions, private fb: FormBuilder, private userService: UserService, private router: Router, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.form = this.fb.group({
      email: [null, Validators.compose([Validators.required, Validators.email])]
    });

  }

  onLinkSendClicked() {
    this.userService.sendResetPasswordLink(this.form.get('email').value)
      .subscribe(res => {
          this.sessionActions.pushMessage("Eine E-Mail mit weiteren Anweisungen zum Zurücksetzen des Passworts wurde an Ihre Adresse verschickt!", MessageType.SUCCESS, "Passwort zuurücksetzen");
          setTimeout(() => this.router.navigate(['/login']), 5000);
        },
        error => {
          console.error("Fehler", [error]);
          const body = error.json() || '';
          const err = body.error || JSON.stringify(body);
          this.sessionActions.pushMessage("Es ist ein Fehler aufgetreten: " + err, MessageType.ERROR, "Passwort zurücksetzen");
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/password-change/password-reset-link/password-reset-link.component.ts